{
  "aiGeneratedAnswer": "AI 產生的答案",
  "allCategories": "所有分類",
  "appliedFiltersToCurrentSearch": "已套用至目前搜尋的篩選器",
  "apply": "套用",
  "applyFilters": "套用篩選器",
  "autocompleteOptionsFound_other": "找到 {{count}} 個{{label}}自動完成選項。",
  "autocompleteSuggestion": "自動完成建議：{{suggestion}}",
  "autocompleteSuggestionsFound_other": "找到 {{count}} 個自動完成建議。",
  "basedOnYourDevice": "（依據您的裝置）",
  "basedOnYourInternetAddress": "（依據您的網際網路位址）",
  "categoriesText_other": "以下分類包含與<strong>{{query}}</strong>相關的結果",
  "clearAll": "清除全部",
  "clearMinAndMax": "清除最小值與最大值",
  "clearTheRangeToSelectOptions": "清除範圍以選擇選項。",
  "clearTheSearchBar": "清除搜尋欄",
  "conductASearch": "進行搜尋",
  "currentLocation": "目前位置",
  "didYouMean": "您的意思是 <button>{{correctedQuery}}</button> 嗎",
  "dropDownScreenReaderInstructions": "有自動完成結果時，請使用上下鍵瀏覽並按 Enter 鍵選取。",
  "feedback": "回饋",
  "filterGroupSearchInputLabel": "搜尋{{title}}選項",
  "invalidRange": "無效範圍",
  "max": "最大",
  "min": "最小",
  "navigateToTheNextResultsPage": "前往下一頁結果",
  "navigateToThePreviousResultsPage": "前往上一頁結果",
  "noAutocompleteOptionsFound": "未找到自動完成選項。",
  "noAutocompleteSuggestionsFound": "未找到自動完成建議。",
  "noResultsFoundIn": "在{{currentVerticalLabel}}中找不到結果。",
  "paginationPage": "第 {{pageNumber}} 頁",
  "pagination": "分頁",
  "readMoreAbout": "閱讀更多關於<a>{{name}}</a>的資訊",
  "recentSearch": "最近搜尋：{{query}}",
  "recentSearchesFound_other": "找到 {{count}} 筆最近搜尋。",
  "removeFilter": "移除「{{displayName}}」篩選器",
  "resultPreview": "結果預覽：{{value}}",
  "resultPreviewsFound_other": "找到 {{count}} 筆結果預覽。",
  "resultsCountText_other": "{{count}} 筆結果",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} / 共 {{resultsCount}} 筆結果",
  "searchHere": "請在此搜尋…",
  "showingAllInstead": "顯示所有 {{currentVerticalLabel}}。",
  "showLess": "顯示較少",
  "showMore": "顯示更多",
  "sources_other": "來源（{{count}}）",
  "submitSearch": "提交搜尋",
  "suggestionResultsCount_other": "{{label}} – {{count}} 筆結果",
  "thankYouForYourFeedback": "感謝您的意見回饋！",
  "thisAnsweredMyQuestion": "這有回答到我的問題",
  "thisDidNotAnswerMyQuestion": "這沒有回答到我的問題",
  "unselectAnOptionToEnterInARange": "取消選擇一個選項以輸入範圍。",
  "updateYourLocation": "更新您的位置",
  "useCurrentLocation": "使用目前位置",
  "useMyLocation": "使用我的位置",
  "viewAll": "查看全部",
  "viewDetails": "查看詳細資料"
}
